<template>
    <modal v-model="openModal" v-on:close="close" :title="trans(`general.page.planners.${getTitle()}`)">
        <div class="row g-2">
            <div class="col-12 mt-2">
                <div class="form-floating">
                    <input type="text" v-model="model.name" class="form-control" id="name" name="name"
                           required placeholder="Name">
                    <label for="name">
                        {{ trans('general.page.planners.field.name') }}
                        <span class="text-gray-900">{{ type === 'event' ? trans('general.page.planners.event_name_info') : ''}}</span>
                    </label>
                </div>
            </div>
            <div class="col-12 col-md-6  mt-3">
                <div v-if="!model.id"
                     class=" d-inline-block p-1 px-3 border-radius-20 bg-light-blue justify-content-sm-between mb-2">
                    <label class="form-check-label me-2 hov-pointer" for="publishNow">
                        {{ trans('general.page.planners.publish_now') }}
                    </label>
                    <input class="form-check-input" type="checkbox" v-model="publishNow" :value="true"
                           id="publishNow">
                </div>
                <div v-if="!publishNow" class="form-floating">
                    <datetime id="publishedAt" class="form-control" v-model="model.published_at"
                              firstDayOfWeek="1" format="yyyy-MM-dd"></datetime>
                    <label for="publishedAt">{{ trans("general.page.planners.field.published_at") }}</label>
                </div>
            </div>
            <div class="col-12 mt-3">
                <div v-if="type === 'menu' || type === 'activity'"
                     class=" d-inline-block p-1 px-3 border-radius-20 bg-light-blue justify-content-sm-between">
                    <label class="form-check-label me-2 hov-pointer" for="chooseCustomClasses">
                        {{ trans('general.page.classes.class_menu.fields.apply_to_all') }}
                    </label>
                    <input class="form-check-input" type="checkbox" v-model="allClasses" :value="true"
                           id="chooseCustomClasses">
                </div>
            </div>

        </div>
        <div class="row g-2">
            <div class="col-12 mt-3" v-if="type === 'menu' || type === 'activity'">

                <h6 v-if="!allClasses" class="h6 mt-2">
                    {{ trans('general.page.classes.class_menu.choose_classes') }}:</h6>
                <class-selection v-if="!allClasses" :css="['col-md-6 col-lg-6 col-xl-4 mb-3']"
                                 @change="selectedClasses = $event" :required="true" :single="false"
                                 @allClassesSelected="onALlClasses"
                                 :selected="model.classes" :limit="50">
                </class-selection>
            </div>
        </div>
        <div class="modal-footer">
            <div class="btn-group no-arrow dropup dropup-center" v-if="model.id && deleteBtn">
                <button type="button" class="btn btn-delete btn-secondary  btn-icon-split dropdown-toggle "
                        data-bs-toggle="dropdown" aria-expanded="false">
                    <span class="text"> {{ trans('general.defaults.delete') }} </span>
                    <i class="icon fi fi-rr-trash"></i>
                </button>
                <ul class="dropdown-menu">
                    <li><h6 class="dropdown-header">{{ trans('general.component.delete_popup.title') }}</h6>
                    </li>
                    <li>
                        <button v-on:click="deleteEvent(model.id)"
                                class="btn btn-link dropdown-item text-danger">
                            {{ trans('general.component.delete_popup.yes') }}
                        </button>
                    </li>
                    <li><a class="btn btn-link dropdown-item text-success"
                           href="#">{{ trans('general.component.delete_popup.no') }}</a></li>
                </ul>
            </div>

            <basic-button
                cls="btn-primary"
                :text="trans('general.defaults.save')"
                @click="submit"
                :disabled="$wait.is('submit-planner')"
                :loading="$wait.is('submit-planner')"
                />
        </div>
    </modal>
</template>
<script>
import Modal from "../../../theme/organisms/Modal";
import datetime from 'vuejs-datepicker';
import EventFormHead from "../atoms/EventFormHead";
import FormErrorAlerts from "../../../theme/molecules/FormErrorAlerts";
import ClassSelection from "../../../theme/atoms/ClassSelection";
import WaitingIndicatorIcon from "../../../theme/atoms/WaitingIndicatorIcon";
import BasicButton from "../../../theme/atoms/BasicButton.vue";
import moment from "moment";

export default {
    name: "PlannerFormModal",
    props: {
        type: String,
        showModal: Boolean,
        values: Object,
        deleteBtn: {
            default: true,
            type: Boolean
        }
    },
    components: {
        Modal,
        datetime,
        EventFormHead,
        FormErrorAlerts,
        ClassSelection,
        WaitingIndicatorIcon,
        BasicButton
    },
    data() {
        return {
            errors: [],
            openModal: this.showModal,
            publishNow: true,
            selectedClasses: null,
            isFirstTime: true,
            allClasses: false,
            initialModel: {
                id: null,
                type: null,
                name: null,
                published_at: null,
                classes: null
            },
            model: {
                id: null,
                type: null,
                name: null,
                published_at: null,
                classes: null
            }
        }
    },
    methods: {
        getTitle() {
            const map = {
                'activity': 'activities',
                'event': 'events'
            }
            return map[this.type] ?? this.type;
        },
        onALlClasses(event) {
            this.allClasses = event && (this.allClasses || this.isFirstTime);
            this.isFirstTime = false;
        },
        open(model) {
            this.clear();
            this.model = {...this.model, ...(model || {})} || this.model;
            if (this.model.published_at) {
                this.publishNow = false;
            }
            this.openModal = true;
            this.allClasses = !this.model.id;
        },
        clear() {
            this.publishNow = true;
            this.isFirstTime = true;
            this.activity = null;
            this.errors = [];
            this.model = {...this.initialModel};
        },
        close() {
            this.openModal = false;
            this.clear()
        },
        submit() {
            this.$wait.start('submit-planner');
            const url = !this.model.id ? `/planners/new` : `/planners/${this.model.id}`;
            this.model.type = this.type;

            this.model.published_at = this.publishNow || !this.model.published_at
                ? null : moment(this.model.published_at).format('YYYY-MM-DD');

            if (this.type === 'menu' || this.type === 'activity') {
                this.model.classes = (this.allClasses) ? null : this.selectedClasses
            } else {
                this.model.classes = null;
            }

            axios.post(url, this.model)
                .then(response => {
                    this.$emit('calendar-saved', response.data.data);
                    this.$wait.end('submit-planner');
                })
                .catch(error => {
                    this.$wait.end('submit-planner');
                    if (error.response.data.message === '' && error.response.data.errors) {
                        let errors = Object.values(error.response.data.errors);
                        this.errors = errors.map(val => val[0] || 0)
                    } else {
                        this.$notify({type: 'error', text: error.response.data.message});
                    }
                })
        },
        deleteEvent(id) {
            axios.delete(`/planners/${id || this.model.id}`)
                .then(response => this.$emit('calendar-deleted', response.data.data))
                .catch(error => {
                    if (error.response.data.message === '' && error.response.data.errors) {
                        let errors = Object.values(error.response.data.errors);
                        this.errors = errors.map(val => val[0] || 0)
                    } else {
                        this.$notify({type: 'error', text: error.response.data.message});
                    }
                })
        },
        titleChanged(event) {
            this.titleSelect = event;
        }
    },
    mounted() {
        this.model = this.initialModel;

        if (this.values) {
            this.model = {...this.model, ...this.values};
        }
    }
}
</script>
